import { useState } from 'react';
import { Link, useLocation } from 'react-router';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/features', label: 'Features' },
  { to: '/contact', label: 'Contact' },
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 border-b border-border bg-background/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 text-xl font-bold tracking-tight">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-red-accent">
            <svg width="24" height="18" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 2L24 6.5V17.5L16 22L8 17.5V6.5L16 2Z" stroke="#F0F0F5" strokeWidth="1.3" fill="#0A0A0F" />
              <path d="M10 7L4 4" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M9 10L3 10" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M9 14L3 14" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M10 17L4 20" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M22 7L28 4" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M23 10L29 10" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M23 14L29 14" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M22 17L28 20" stroke="#F0F0F5" strokeWidth="1" strokeLinecap="round" />
              <path d="M16 8L20 10.5V15.5L16 18L12 15.5V10.5L16 8Z" fill="#F2555A" />
              <circle cx="16" cy="12" r="1.5" fill="#E5484D" />
            </svg>
          </span>
          <span className="text-text-primary">Redbax</span>
        </Link>

        {/* Desktop links */}
        <div className="hidden items-center gap-8 md:flex">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className={`text-sm font-medium transition-colors hover:text-text-primary ${
                location.pathname === to ? 'text-text-primary' : 'text-text-secondary'
              }`}
            >
              {label}
            </Link>
          ))}
          <a
            href="https://app.redbax.io"
            className="rounded-lg border border-border px-4 py-2 text-sm font-semibold text-text-primary transition-colors hover:border-text-secondary hover:bg-surface"
          >
            Sign In
          </a>
          <Link
            to="/contact"
            className="rounded-lg bg-red-accent px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-hover"
          >
            Register Interest
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          onClick={() => setOpen(!open)}
          className="text-text-secondary transition-colors hover:text-text-primary md:hidden"
          aria-label={open ? 'Close menu' : 'Open menu'}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="border-t border-border bg-background px-6 pb-6 pt-4 md:hidden">
          <div className="flex flex-col gap-4">
            {navLinks.map(({ to, label }) => (
              <Link
                key={to}
                to={to}
                onClick={() => setOpen(false)}
                className={`text-sm font-medium transition-colors hover:text-text-primary ${
                  location.pathname === to ? 'text-text-primary' : 'text-text-secondary'
                }`}
              >
                {label}
              </Link>
            ))}
            <a
              href="https://app.redbax.io"
              className="rounded-lg border border-border px-4 py-2 text-center text-sm font-semibold text-text-primary transition-colors hover:border-text-secondary hover:bg-surface"
            >
              Sign In
            </a>
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="rounded-lg bg-red-accent px-4 py-2 text-center text-sm font-semibold text-white transition-colors hover:bg-red-hover"
            >
              Register Interest
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}
